/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M15.9393 23.5607A1.5002 1.5002 0 0 1 14.8787 24H5c-1.6568 0-3-1.3431-3-3V3c0-1.6568 1.3432-3 3-3h13.5c1.6569 0 3 1.3432 3 3v14.3787a1.5002 1.5002 0 0 1-.4393 1.0606l-5.1214 5.1214Zm2.6894-4.8107H16.25v2.3787l2.3787-2.3787ZM3.5 21c0 .8284.6716 1.5 1.5 1.5h9.75v-4.35a.9.9 0 0 1 .9-.9H20V3c0-.8284-.6716-1.5-1.5-1.5H5c-.8284 0-1.5.6716-1.5 1.5v18Zm3-15.75a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75Zm0 4.5A.75.75 0 0 1 7.25 9h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75Zm.75 3.75a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5Z"
    clipRule="evenodd"
  />,
  'News'
);
